export default function BasquiatCrownIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M412.16,110.64c-10.06,176.71-22.99,278.72-22.99,278.72-56.87-9.68-118.56-12.48-170.95-12.48-72.02,0-126.44,5.3-126.44,5.3l-3.59-262.2,94.82,155.16,80.45-139.36,38.79,122.12,109.91-147.26M412.17,85.64c-7.73,0-15.22,3.59-20.04,10.05l-80.78,108.24-24.05-75.71c-3-9.44-11.29-16.22-21.13-17.29-.9-.1-1.81-.15-2.7-.15-8.86,0-17.15,4.71-21.64,12.5l-59.41,102.92-72.88-119.26c-4.63-7.57-12.79-11.97-21.33-11.97-2.31,0-4.64.32-6.94.98-10.82,3.12-18.22,13.1-18.06,24.36l3.59,262.2c.1,6.99,3.12,13.62,8.33,18.29,4.6,4.12,10.55,6.37,16.67,6.37.81,0,1.61-.04,2.42-.12.53-.05,54.19-5.18,124.02-5.18,63.38,0,119.48,4.08,166.76,12.13,1.4.24,2.8.35,4.2.35,5.33,0,10.55-1.7,14.89-4.92,5.47-4.06,9.05-10.18,9.91-16.94.13-1.03,13.15-104.89,23.15-280.44.63-11.02-6.04-21.14-16.41-24.91-2.8-1.02-5.69-1.51-8.54-1.51h0Z"/>
    </svg>
  );
}
